const INITIAL_STATE = {
    confirmationMail: null,
    mobileNumber: null,
    paidAmount: null,
    paidExcursions: null,
    paidTacEntries: null,
    paymentReference: null,
    tomcatInstance: null
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_PAYMENT':
            return {
                confirmationMail: action.payment.confirmationMail,
                mobileNumber: action.payment.mobileNumber,
                paidAmount: action.payment.paidAmount,
                paidExcursions: action.payment.paidExcursions,
                paidTacEntries: action.payment.paidTacEntries,
                paymentReference: action.payment.paymentReference,
                tomcatInstance: action.payment.tomcatInstance
            };

        case 'CLEAR_PAYMENT':
            return INITIAL_STATE;

        default:
            return state;
    }
}
